import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';
import LandingPage from '@/pages/LandingPage';
import Wordmark from '@/components/Wordmark';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch {
      toast.error('Noget gik galt. Prøv igen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen">
      <div className="fixed inset-0 overflow-auto blur-sm brightness-50 pointer-events-none">
        <LandingPage />
      </div>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="absolute inset-0 bg-[var(--surface-overlay)]" onClick={() => navigate('/')} />
        <Card className="relative z-10 w-full max-w-md p-8 bg-th-sidebar border-th-border shadow-2xl shadow-brand-500/10">
          <div className="flex justify-center mb-6">
            <a href="/" className="flex items-center gap-3">
              <Mail size={40} className="text-brand-500" />
              <span className="text-2xl font-heading font-bold text-th-text">
                <Wordmark />
              </span>
            </a>
          </div>

          {sent ? (
            <div className="text-center space-y-4">
              <h1 className="text-2xl font-heading font-bold text-th-text">Tjek din indbakke</h1>
              <p className="text-th-text-secondary">
                Hvis <span className="text-th-text-secondary">{email}</span> er registreret, har vi sendt et link til nulstilling af adgangskode. Det er gyldigt i 1 time.
              </p>
              <Button className="w-full h-12 bg-btn hover:bg-btn-hover text-btn-fg" onClick={() => navigate('/login')}>
                Tilbage til login
              </Button>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-heading font-bold text-th-text text-center mb-2">
                Glemt adgangskode?
              </h1>
              <p className="text-th-text-secondary text-center mb-8">
                Indtast din e-mail, så sender vi et nulstillingslink.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="relative">
                  <Mail size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-th-text-muted" />
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="din@email.dk"
                    required
                    autoFocus
                    className="pl-10 h-12 bg-th-input border-th-border-light text-th-text placeholder:text-th-text-muted"
                  />
                </div>
                <Button type="submit" disabled={loading} className="w-full h-12 bg-btn hover:bg-btn-hover text-btn-fg text-lg">
                  {loading ? 'Sender...' : 'Send nulstillingslink'}
                </Button>
              </form>
              <div className="mt-6 text-center">
                <a href="/login" className="text-th-text-muted hover:text-brand-400 text-sm">Tilbage til login</a>
              </div>
            </>
          )}
        </Card>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
